<template>
  <v-dialog v-model="dialog" max-width="400px" persistent>
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark v-on="on">
        <v-icon>download</v-icon>
        Download Excel
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Download Excel</span>
        <v-spacer></v-spacer>
        <v-icon color="red darken-1" flat large @click="dialog = false">
          close
        </v-icon>
      </v-card-title>
      <v-container class="pa-3">
        <v-form>
          <v-layout wrap>
            <v-flex xs12>
              <h3 class="error pa-2 text-white" v-if="errorMsg">
                {{ errorMsg }}
              </h3>
              <h3 class="success pa-2 text-white" v-if="successMsg">
                {{ successMsg }}
              </h3>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Limit"
                prepend-icon="group"
                v-model="limit"
              />
              <!-- Start Date -->
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="start_date"
                    label="Start Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="start_date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
              <!-- End Date -->
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="end_date"
                    label="End Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="end_date"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
              <v-btn
                color="primary"
                @click="download"
                :loading="loading"
                :disabled="loading"
              >
                Download
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
  import HTTP from "@/utils/HTTP";
  import downloadExcelFile from "@/lib/downloadExcelFile";

  export default {
    props: ["apiUrl"],
    data: () => ({
      loading: false,
      dialog: false,
      errorMsg: "",
      successMsg: "",
      limit: 100,
      start_date: new Date(new Date().setMonth(new Date().getMonth() - 1))
        .toISOString()
        .substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
    }),
    watch: {
      dialog() {
        this.errorMsg = "";
        this.successMsg = "";
      },
    },
    methods: {
      async download() {
        this.loading = true;
        this.successMsg = this.errorMsg = "";
        try {
          const { data } = await HTTP().get(
            `${this.apiUrl}&limit=${this.limit}&start_date=${this.start_date}&end_date=${this.end_date}`,
            {
              responseType: "blob",
            }
          );

          if (data.error) {
            this.errorMsg = data.errorMsg;
          } else {
            downloadExcelFile(data, `user-list-${this.limit}.xlsx`);
            this.successMsg = data.errorMsg;
            this.dialog = false;
          }
          // console.log(data);
        } catch (error) {
          this.errorMsg = "Something wrong happened. Please try again";
          // console.log(error);
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
<style scoped>
  .text-white {
    color: #fff !important;
  }
</style>
